// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from 'react-i18next';

const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 30vw;
    @media (max-width: 768px) {
      max-width: 95vw;
    }
  }
  .modal-content {
    background-image: url('/assets/ui/container-bg.png');
    background-repeat: round;
    background-size: cover;
    color: #fff;
    border-radius: 8px;
    padding: 15px;
    overflow: hidden;
  }
  .modal-header .btn-close {
    filter: invert(1);
    opacity: 1;
  }
`;

const StyledModalFooter = styled(Modal.Footer)`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;
  padding: 15px;
`;

const StyledModalBody = styled(Modal.Body)`
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 15px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
`;

const StyledButton = styled.button`
  background-color: #ffcc00;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  flex: 1;
  max-width: 120px;
  text-align: center;

  &:hover {
    background-color: #ffd633;
  }
  &:disabled {
    background-color: #555;
    cursor: not-allowed;
  }
  @media (max-width: 768px) {
    max-width: 100px;
    font-size: 12px;
  }
`;

const SystemModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get("popup");
  let msg = searchParams.get("msg");
  const { t } = useTranslation();

  // 🔥 Verhindert das Öffnen des Popups für NULL, "NULL" oder leere Werte
  const isValidMessage = msg && msg.trim() !== "" && msg !== "NULL";

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (type && isValidMessage) {
      setShow(true);
    } else {
      setShow(false); // Falls keine gültige Nachricht vorhanden ist, sicherstellen, dass es geschlossen wird
    }
  }, [type, msg, isValidMessage]);

  useEffect(() => {
    const handleClosePopup = () => setShow(false);
    window.addEventListener("closePopup", handleClosePopup);

    return () => {
      window.removeEventListener("closePopup", handleClosePopup);
    };
  }, []);

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("popup");
      newParams.delete("msg");
      setSearchParams(newParams); // 🔥 Entfernt die Popup-Parameter aus der URL
    }, 300);
  };

  const modalStyles = {
    success: { title: t('modal.success'), color: 'green' },
    error: { title: t('modal.error'), color: 'red' },
    warning: { title: t('modal.warning'), color: 'orange' },
    info: { title: t('modal.info'), color: 'blue' },
  };

  const { title, color } = modalStyles[type] || modalStyles.info;

  if (!show) return null; // 🔥 Stellt sicher, dass das Modal NICHT gerendert wird, wenn `show === false`

  return (
    <StyledModal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ color }}>{title}</Modal.Title>
      </Modal.Header>
      <StyledModalBody style={{ textAlign: "center", fontSize: "1.2rem" }}>
        {decodeURIComponent(msg)}
      </StyledModalBody>
      <StyledModalFooter>
        <StyledButton onClick={handleClose}>Close</StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};

export default SystemModal;
